export const departments = [
  {
    id: 1,
    name: 'IT',
  },
  {
    id: 4,
    name: 'General',
  },
  {
    id: 14,
    name: 'Juridic',
  },
  {
    id: 19,
    name: 'APP',
  },
  {
    id: 20,
    name: 'Director',
  },
  {
    id: 21,
    name: 'Birou Autorizatii/Avize',
  },
  {
    id: 22,
    name: 'Birou Documentatii',
  },
  {
    id: 23,
    name: 'Registratura',
  },
  {
    id: 24,
    name: 'Primar',
  },
  {
    id: 25,
    name: 'Secretar',
  },
];
